/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
import { useCallback } from 'react';
import {
  Grid,
} from '@mui/material';
import { useDropzone } from 'react-dropzone';

import './index.scss';

export default function AddLogoCompany(props: any) {
  const { image, onLoad } = props;
  const onDrop = useCallback((acceptedFiles) => {
    onLoad(acceptedFiles[0]);
  }, [])

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/jpeg, image/png',
    multiple: false,
    onDrop,
  });

  return (
    <Grid
      sx={{
        width: '100%',
        height: '100%',
        cursor: 'pointer',
      }}
      {...getRootProps({ className: 'dropzone-logo' })}
    >
      <input {...getInputProps()} />
      <Grid
        sx={{
          width: '100%',
          height: '100%',
        }}
      >
        {image}
      </Grid>
    </Grid>
  );
}
